<template>
  <div
    class="mx-auto h-[1040px] w-[1920px] border border-t-0 border-[#eee] bg-[#004c93]"
  >
    <BrandTheme theme="accadisBITheme">
      <div class="p-8">
        <div class="-m-3 flow-root">
          <div id="hero" class="mt-4">
            <div class="relative overflow-hidden">
              <div class="pt-10 pb-2 text-center text-5xl font-bold text-white">
                Dafür steht accadis
              </div>
              <div
                class="px-8 pt-1 text-center text-4xl font-normal text-white"
              />
            </div>
          </div>
        </div>
      </div>

      <div>
        <div class="center">
          <div class="test">
            <div class="relative">
              <UCarousel
                ref="carousel"
                v-slot="{ item }"
                :items="slides"
                :autoplay="{ delay: 6000 }"
                loop
                :arrows="false"
                :dots="false"
                class="box"
                @select="activeIndex = $event"
              >
                <div class="-m-3 flex h-full flex-wrap items-center py-16">
                  <div
                    class="colorline-nogrey w-full shrink-0 p-4 pt-16 pb-0 text-center text-8xl font-light md:w-6/12 md:p-12 lg:p-16"
                  >
                    {{ item.title }}
                    <div class="my-4 md:my-6" />
                  </div>
                  <div
                    class="w-full shrink-0 p-8 text-center text-4xl md:w-6/12 md:p-12 md:text-left"
                  >
                    {{ item.text }}
                  </div>
                </div>
              </UCarousel>

              <div
                class="absolute inset-x-0 top-0 z-10 flex h-[50px] items-center justify-center p-8"
              >
                <button
                  v-for="(slide, i) in slides"
                  :key="slide.title"
                  type="button"
                  class="mx-2 flex size-15 items-center justify-center text-[5.25rem] leading-none font-bold text-black"
                  :aria-label="slide.title"
                  :aria-current="i === activeIndex"
                  @click="carousel?.emblaApi?.scrollTo(i)"
                >
                  {{ slide.title.charAt(0) }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </BrandTheme>
  </div>
</template>

<script lang="ts" setup>
const slides = [
  {
    text: 'Akzeptanz | Wir schätzen die Einzigartigkeit jedes Einzelnen und fördern eine inklusive Gemeinschaft.',
    title: 'a | acceptance',
  },
  {
    text: 'Einfühlungsvermögen | Wir begegnen einander mit Empathie und Verständnis.',
    title: 'c | compassion',
  },
  {
    text: 'Höflichkeit | Wir behandeln einander mit Respekt und Würde, um eine positive Lernumgebung zu schaffen.',
    title: 'c | courtesy',
  },
  {
    text: 'Zielstrebigkeit | Wir setzen ambitionierte Ziele und freuen uns über Erreichtes.',
    title: 'a | ambition',
  },
  {
    text: 'Engagement | Wir engagieren uns mit Leidenschaft für unsere Gemeinschaft, Bildungsziele und Werte.',
    title: 'd | dedication',
  },
  {
    text: 'Integrität | Wir handeln ehrlich und ethisch – so stärken wir das Vertrauen in unsere Gemeinschaft.',
    title: 'i | integrity',
  },
  {
    text: 'Hilfsbereitschaft | Wir bieten stets unsere Hilfe an und haben die Bedürfnisse anderer im Blick.',
    title: 's | service',
  },
];

const carousel = useTemplateRef('carousel');
const activeIndex = ref(0);
</script>

<style lang="scss">
.test {
  background-color: rgb(242, 242, 239);
  padding: 50px;
}

.center {
  width: 90%;
  color: black;
  margin: auto;
  padding: 150px 10px;
}
.box {
  background-color: rgb(242, 242, 239);
}

.colorline-nogrey:after {
  content: '';
  width: 100%;
  display: block;
  height: 5px;

  background: rgb(0, 76, 147);
  background: linear-gradient(
    90deg,
    #929596 0%,
    #929596 33%,
    rgba(0, 76, 147, 1) 33%,
    rgba(0, 76, 147, 1) 66%,
    rgba(249, 177, 35, 1) 66%,
    rgba(249, 177, 35, 1) 100%
  );
}
</style>
